import IconWrapper from '../navigation/card/iconWrapper.component'
import Slogan from '../slogan.component'
import Toolbar from './toolbar.component'

interface ICompactBlockContentProps {
  slogan: string
  headerData: any
}

const CompactBlockContent: React.FC<ICompactBlockContentProps> = ({
  slogan,
  headerData,
}) => {
  const { iconUrl, iconColor, fontColor, name_HU } = headerData
  return (
    <div className='h-[250px] flex flex-col items-end gap-desktop relative py-4 xl:py-8 justify-between'>
      <div className='w-1/3 2xl:w-3/4'>
        <Toolbar />
      </div>
      <div className='w-full text-white h-full flex items-center justify-center pl-1/3 2xl:pl-0 h-[100px] 2xl:h-[150px]'>
        {iconUrl ? (
          <IconWrapper
            iconColor={iconColor}
            fontColor={fontColor}
            iconUrl={iconUrl}
            name={name_HU}
            large
            tabIndex
            inHeader
          />
        ) : (
          <Slogan slogan={slogan} />
        )}
      </div>
    </div>
  )
}

export default CompactBlockContent
